import { render, staticRenderFns } from "./imgD.vue?vue&type=template&id=7715605d&scoped=true"
var script = {}
import style0 from "./imgD.vue?vue&type=style&index=0&id=7715605d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7715605d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7715605d')) {
      api.createRecord('7715605d', component.options)
    } else {
      api.reload('7715605d', component.options)
    }
    module.hot.accept("./imgD.vue?vue&type=template&id=7715605d&scoped=true", function () {
      api.rerender('7715605d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgD.vue"
export default component.exports